export const DELETE_SELECTION_COPY = {
  title: 'Delete entities?',
  text: 'This action cannot be undone.',
  toChangeTitle: 'Will be deleted',
  toSkipTitle: 'Will not be deleted',
  confirmName: 'Delete entities',
  assetTitle: 'Delete entity?',
  assetConfirmName: 'Confirm',
  assetSuccess: 'Asset risk assessment model has been successfully deleted',
  allBlockedError:
    "All selected entities can't be deleted because they have AND relationships with the last auto-assigned weight value. Delete those relationships first.",
  successWithCount: (count: number) =>
    `${count} entities have been successfully deleted.`,
};
